import { Component, OnInit, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ContractsNextExpirationLargeAccountsService } from '../../services/contracts-next-expiration-large-accounts.service';
import { ContractsNextExpirationPymesService } from '../../services/contracts-next-expiration-pymes.service';
import { ContractsNextExpiration, ContratosList } from 'src/app/interfaces';
import { ColLabel, IButtonTable } from '../table/table.interface';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth';
import { UtilService } from 'src/app/services/util.service';
@Component({
  selector: 'app-contracts-next-expiration',
  templateUrl: './contracts-next-expiration.component.html'
})
export class ContractsNextExpirationComponent implements OnInit {
  @Input()
  home: string;

  destroyed$: Subject<boolean> = new Subject<boolean>();

  isLoading = true;

  data: ContractsNextExpiration;

  mesActual: number;
  dosMeses: number;
  tresMeses: number;
  contratosList: ContratosList[];

  colsTable: ColLabel[] = [];
  public isUserSpanish = true;

  constructor(
    private contractsNextExpirationPymes: ContractsNextExpirationPymesService,
    private contractsNextExpirationLargeAccounts: ContractsNextExpirationLargeAccountsService,
    private utilService: UtilService,
    private router: Router,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.isUserSpanish = this.authService.getUserData().country === 'ES';
    if (this.home == 'Pymes') {
      this.contractsNextExpirationPymes
        .getContractsNextExpirationPymes()
        .pipe(takeUntil(this.destroyed$))
        .subscribe(
          res => {
            this.data = res.data;
            this.mesActual = this.data.mesActual;
            this.dosMeses = this.data.dosMeses;
            this.tresMeses = this.data.tresMeses;

            this.contratosList = this.data.contratosList.map(value => {
              value.hidden = !this.authService.getOnlyCanRead();
              return value;
            });

            this.colsTable = [
              {
                label: this.isUserSpanish ? 'NEW_CONTRACTS.CONTRACT_CODE' : 'NEW_CONTRACTS.CONTRACT_CODE_DEBT',
                field: this.isUserSpanish ? ['codigoContrato'] : ['codigoContrato', 'deuda'],
                fieldClass: this.isUserSpanish ? [''] : ['', 'currency'],
                action: ''
              },
              {
                label: 'HOME.BUSINESS_NAME',
                field: ['nombreRazonSocial'],
                fieldClass: [''],
                action: ''
              },
              {
                label: 'HOME.CUPS',
                field: ['cups'],
                fieldClass: [''],
                action: ''
              },
              {
                label: 'HOME.END_CONTRACT',
                field: ['fechaFinDefinitiva'],
                fieldClass: ['date'],
                action: ''
              },
              {
                label: '',
                field: ['idContrato'],
                fieldClass: ['buttonFixed'],
                action: 'goToClicked',
                nameIcon: 'arrow',
                columnClass: 'buttonFixed',
                hiddenIcon: ['hidden']
              }
            ];

            this.isLoading = false;
          },
          error => {
            this.utilService.toastErrors(error);
          }
        );
    } else {
      this.contractsNextExpirationLargeAccounts
        .getContractsNextExpirationLargeAccounts()
        .pipe(takeUntil(this.destroyed$))
        .subscribe(
          res => {
            this.data = res.data;

            this.mesActual = this.data.mesActual;
            this.dosMeses = this.data.dosMeses;
            this.tresMeses = this.data.tresMeses;

            this.contratosList = this.data.contratosList;

            this.colsTable = [
              {
                label: 'NEW_CONTRACTS.CONTRACT_CODE_DEBT',
                field: ['codigoContrato', 'deuda'],
                fieldClass: ['', 'currency'],
                action: ''
              },
              {
                label: 'NEW_CONTRACTS.BUSINESS_NAME_TRADING_ACCOUNT',
                field: ['nombreRazonSocial', 'nombreCuentaNegociadora'],
                fieldClass: ['', ''],
                action: ''
              },
              {
                label: 'HOME.INSTALLATION',
                field: ['nombreInstalacion'],
                fieldClass: [''],
                action: ''
              },
              {
                label: 'HOME.END_CONTRACT',
                field: ['fechaFinDefinitiva'],
                fieldClass: ['date'],
                action: ''
              },
              {
                label: '',
                field: ['idContrato'],
                fieldClass: ['buttonFixed'],
                action: 'goToClicked',
                nameIcon: 'arrow',
                columnClass: 'buttonFixed'
              }
            ];
            this.isLoading = false;
          },
          error => {
            this.utilService.toastErrors(error);
          }
        );
    }
  }

  public handleButton(event: IButtonTable): void {
    if (event.data.idContrato) {
      this.router.navigate(['customers/next-expiration/contract'], {
        queryParams:
          { idContract: event.data.idContrato, renovate: event.data.allowRenovacion }
      });
    }
  }

  public handleNavigate(): void {
    this.router.navigate(['customers'], { queryParams: { tab: 1 } });
  }
}
